import groupBy from 'lodash/groupBy';
import { arrayOf, bool, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Swimlanes from '../../layout/Swimlanes';
import Titled from '../../layout/Titled';
import {
  opportunityBudgetsShape,
  opportunityShape,
  optionShape,
} from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import isPermitted from '../../utils/is-permitted';
import BudgetData from '../BudgetData';
import OpportunityLane from '../OpportunityLane';
import withOpportunitiesAsData from '../with-opportunities-as-data';

class SwimlaneOpportunities extends React.PureComponent {
  render() {
    const {
      showAddButton,
      categories,
      data,
      groupBy: groupByKey,
      budgets,
    } = this.props;

    const groupedData = groupBy(data, groupByKey);

    return (
      <Titled
        title={
          <BudgetData
            openBudget={budgets.openBudget}
            securedBudget={budgets.securedBudget}
            securedPushedBudget={budgets.securedPushedBudget}
          />
        }
        size="reg"
        actions={
          showAddButton && (
            <Link to="/opportunities/add" className="btn btn-secondary">
              Create Opportunity
            </Link>
          )
        }
      >
        <Swimlanes className="c-swimlane-wrapper">
          {categories.map(category => (
            <OpportunityLane
              key={category.value}
              category={category}
              opportunities={groupedData[category.value] || []}
            />
          ))}
        </Swimlanes>
      </Titled>
    );
  }
}

SwimlaneOpportunities.propTypes = {
  showAddButton: bool,
  categories: arrayOf(optionShape.isRequired).isRequired,
  data: arrayOf(opportunityShape.isRequired).isRequired,
  groupBy: string.isRequired,
  budgets: opportunityBudgetsShape.isRequired,
};

SwimlaneOpportunities.defaultProps = {
  showAddButton: isPermitted(api.addOpportunity),
};

export { SwimlaneOpportunities };
export default withResolved({
  query: api.getOpportunityBudgets,
  deriveQueryArgs: ({ relevantFor, relevantForSalesTeam }) => ({
    search: { relevantFor, relevantForSalesTeam },
  }),
  as: 'budgets',
})(withOpportunitiesAsData(SwimlaneOpportunities));
